export const documents = {
  "Meus documentos": "My documents",
  "Pastas de documentos": "Document folders",
  "Documentos avulsos": "Loose documents",
  "Solicitações de documentos": "Document requests",
  "Aqui você pode ver seus documentos salvos na nuvem pela sua empresa.": "Here you can see your documents saved in the cloud by your company.",
  "Você não possui documentos solicitados pela sua empresa": "You have no documents requested by your company",
  "Status assinatura": "Signature status",
  "Todos": "All",
  "Não solicitado": "Not requested",
  "Pendente": "Pending",
  "Assinado": "Signed",
  "Nenhum documento encontrado": "No documents found",
  "Documento": "Document",
  "Descrição": "Description",
  "Assinatura": "Signature",
  "Data de validade": "Expiration date",
  "(Sem nome)": "(No name)",
  "Ver assinatura": "View signature",
  "Envie seus documentos pendentes.": "Submit your pending documents.",
  "Você não possui documentos cadastrados pela sua empresa": "You have no documents registered by your company",
  "Solicitação": "Request",
  "Data Limite": "Deadline",
  "Enviar documento: ": "Send document:",
  "Faça o upload do documento solicitado.": "Upload the requested document.",
  "Arquivo selecionado:": "Selected file:",
  "Excluir documento": "Delete document",
  "Enviar documento": "Send document",
  "Selecione o arquivo": "Select file",
  "ou arraste aqui": "or drag here",
  "Documento com senha": "Password-protected document",
  "Digite sua senha de acesso do aplicativo para abrir este documento": "Enter your application password to open this document",
  "Sua senha": "Your password",
  "* Digite a sua senha": "* Enter your password",
  "Cancelar": "Cancel",
  "Abrir": "Open",
  "Assinatura digital": "Digital signature",
  "Assinado por": "Signed by",
  "E-mail:": "E-mail:",
  "Documento:": "Document:",
  "ID do documento:": "Document ID:",
  "Dados da assinatura:": "Signature details:",
  "Assinado em: ": "Signed on:",
  "ID do aparelho: ": "Device ID:",
  "Modelo do aparelho: ": "Device model:",
  "IP: ": "IP:",
  "Foto:": "Photo:",
  "Assinatura:": "Signature:",
  "Localização:": "Location:",
  "Aviso!": "Warning!",
  "Verifique se você alterou o status.": "Check if you have changed the status.",
  "Aviso": "Warning",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.": "It was not possible to send the image. Reason: file too large, please send a file smaller than 3.5MB.",
  "Não foi possivel realizar o envio. Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.": "It was not possible to send. Reason: file too large, please send a file smaller than 3.5MB.",
  "Documento Enviado!": "Document Sent!",
  "Seu envio de documento foi salvo com sucesso!": "Your document submission was successfully saved!",
  "Erro": "Error",
  "Ocorreu um erro": "An error has occurred",
  "Erro ao salvar arquivo.": "Error saving file.",
  "Voltar": "Back",
  "Pesquisar": "Search",
  "Imprimir log": "Print log",
  "Assinado em:": "Signed on:",
  "Modelo do aparelho:": "Device model:",
  "IP:": "IP:",
  "Localização: ": "Location:",
  "Fechar": "Close",
  "Assinar documento": "Sign document",
  "Entendi!": "Got it!",
  "assinatura": "signature",
  "Aceite de Documento": "Document Acknowledgement",
  "Ao clicar em aceitar, você está dando ciência que comprova o recebimento deste documento.": "By clicking accept, you acknowledge and confirm receipt of this document.",
  "Recusar": "Decline",
  "Aceitar": "Accept",
};



// WEBPACK FOOTER //
// ./src/resources/enUS/documents.js